<template>
  <div class="navbar">
    <img src="../assets/logohorizon.png" class="logo" alt="Logo" @click="toggleMenu">
    <ul class="nav-links" v-if="showMenu" @mouseleave="hideMenu">
      
      <li v-for="link in updatedLinks" :key="link.text" :class="{ selected: link.selected }" @click="setActive(link)">
        <a>
          {{ link.text }}
        </a>
    
        <!-- 如果每个 link 下有子链接，嵌套第二个 v-for -->
        <ul v-if="link.subLinks && link.subLinks.length">
          <li v-for="subLink in link.subLinks" :key="subLink.text" @click="setActive(subLink)">
            {{ subLink.text }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'NavBar',
    props: {
      language: {
        type: String,
        default: "en",
      },
      selectedItem: {
        type: String,
        required: true,
      },
      showNavBar: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        selectedWhich: this.selectedItem,
        selected: {
          type: String,
          default: "false",
        },
        links: [
          { text: 'NEWS', selected: false ,name:'Home'},
          { text: 'ABOUT US', selected: false,name:'AboutUs'},
          { text: 'OUR BUSINESS', selected: false ,name:'OurBusiness'},
          { text: 'CONTACT US', selected: false ,name:'ContactUs'},
        ],
        showMenu: false,
        isMobile:false,
      };
    },
    computed:{
      updatedLinks(){
        console.log("运行了赋值动作")
        return this.links.map(
          link => ({
            ...link,
            selected: this.selectedWhich === link.name,
          })
        )
      }
    },
    watch:{
      selectedItem(newItem,oldItem){
        //if(newItem.length>0){
          this.selectedWhich = newItem
        //}
        console.log("watch selected item cahnge:",this.selectedWhich,newItem,oldItem)
      }
    },
    methods: {
      //鼠标点击导航菜单时设置选中
      setActive(selectedLink) {
        console.log("检测到点击navbar")
        if(this.$route.name == "home"){
          this.$emit('update-selected',selectedLink.name)
          console.log("当前在homepage，直接滚动到：",selectedLink.name)
        }
        else {
          this.$router.push({ name: 'home', params : { id : selectedLink.name } })
          .then(() => {
            this.$nextTick(() => {
              this.$emit('update-selected', selectedLink.name);
              console.log("跳转到homepage并滚动至:", selectedLink.name);
            });
          });
        }
      },
      toggleMenu() {
        if(this.isMobile){
          this.showMenu = !this.showMenu;
        }
      },
      hideMenu() {
        if(this.isMobile){
          this.showMenu = false; // 在方法中使用 showMenu
        }
      },
      updateDeviceType() {
        this.isMobile = window.innerWidth < 768;
        if(!this.isMobile) {
          this.showMenu = true; // 在宽屏上自动隐藏菜单
        }else{
          this.showMenu = false;
        }
      },
    },
    mounted() {
      window.addEventListener('resize', this.updateDeviceType);
      this.updateDeviceType(); // 初始检查
      console.log("Received selectedWhich:", this.selectedWhich); // 调试信息
      //this.setInitialSelection(this.selectedWhich); //设置初始的选中状态
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.updateDeviceType);
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar{
  height : 80px;
  width : 100%;
  display: flex;
  background-color: rgba(0,0,0,70%);
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100; 
}
.logo{
  height: 48px;
  padding-left: 24px;
}
.nav-links {
  list-style: none;
  display: flex;
  padding-right: 24px; /* 设置右侧内边距 */
  margin: 0; /* 移除默认的 margin */
}
.nav-links li {
  width: 192px;
  height: 48px;
  border-radius: 24px;
  margin-left: 16px;
  color: white; /* 默认文字颜色 */
  background-color: transparent; /* 默认背景色 */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s; /* 平滑过渡效果 */
  font-size: 16px;
  letter-spacing: 5%;
}
.nav-links li:first-child{
  margin-left: 0;
}
.nav-links li:hover {
  background-color: #fef8ed; /* 悬浮背景色 */
  color: #5C3819; /* 悬浮文字颜色 */
}
.nav-links .selected {
  background-color: #DEBE84; /* 选中背景色 */
  color: #5C3819; /* 选中文字颜色 */
}
.nav-links li:active {
  background-color: #CEA458; /* 点击背景色 */
  color: #5C3819; /* 点击文字颜色 */
}
/* 媒体查询：屏幕宽度小于768px时应用 */
@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    height: auto;
    display: flex;
    align-items:center;
  }

  .logo {
    padding: 8px;
  }
  .nav-links {
    flex-direction: column;
    align-items: center;
    padding-left: 16px;
    width: 100%;
  }
  .nav-links li {
    width: 100vw; /* 使链接宽度自适应 */
    border-radius: 0px;
    font-size: 14px;
  }
}
</style>
